/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import RegistrationOtpModal from './RegistartionOtpModal'
import {
  fetchAsyncVerifyOtp,
  getUserData,
  ssoLogin,
  UserLoginAuth,
} from './UserLoginRedux/UserLoginSlice'
import {loginSchema} from '../../../../Utils/_helpers/ValidationSchema'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {resetRedux} from '../../../../Redux/store'
// import ReCAPTCHA from 'react-google-recaptcha-v3'
import {useMsal} from '@azure/msal-react'
import {loginRequest} from '../../../../../authConfig'
import {useGoogleLogin} from '@react-oauth/google'
import {toast} from 'react-toastify'
import { ENV } from '../../../../Utils/_helpers/EnvHelper'

export function FrontendLogin() {
  const param = document.location.host
  const isCellcast = param === ENV().REACT_APP_CELLCAST

  const dispatch = useDispatch()
  const {instance} = useMsal()
  const user = useSelector(getUserData)
  const [otpVisible, setOtpVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [OTP, setOTP] = useState<any>()
  const initialValues = {
    email: '',
    password: '',
  }

  const [passwordType, setPasswordType] = useState({
    password: true,
  })

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(false)
      setLoading(true)
      setTimeout(() => {
        let data = {
          email: values.email,
          password: values.password,
        }
        dispatch(resetRedux())
        dispatch(UserLoginAuth(data))
        setLoading(false)
      }, 1000)
    },
  })

  const handleEnter: any = (event: any) => {
    // event.preventDefault()
    const data = {
      otp: OTP,
      mobile: user?.mobile,
      email: user?.email,
      type: user?.otpType || 'SIGNUP_MOBILE',
    }
    dispatch(resetRedux())
    dispatch(fetchAsyncVerifyOtp(data)).then((res: any) => {
      if (!res.error) {
        setOtpVisible(false)
      }
    })
  }

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      if (codeResponse.access_token) {
        const payload = {
          from: 'google',
          token: codeResponse.access_token,
        }
        dispatch(ssoLogin(payload))
      }
    },
    onError: (error) => toast.error(`${error}`),
  })

  useEffect(() => {
    if (user?.otp) {
      setOtpVisible(true)
    }
  }, [user])

  // Handle SSO LOGIN
  const handleSSOLogin = (type: string) => {
    if (type === 'microsoft') {
      instance
        .loginPopup({
          ...loginRequest,
          redirectUri: '/',
        })
        .then((res) => {
          const payload = {
            from: 'microsoft',
            token: res.idToken,
          }
          dispatch(ssoLogin(payload))
        })
    }

    if (type === 'google') {
      handleGoogleLogin()
    }
  }

  return (
    <>
      {
        <>
          {user?.otp && (
            <RegistrationOtpModal
              show={otpVisible}
              handleClose={() => setOtpVisible(false)}
              email={user?.email}
              phoneNumber={user?.mobile}
              stopLoading={undefined}
              handleEnter={() => handleEnter()}
              setOTP={setOTP}
              OTP={OTP}
              otpType={user?.otpType}
            />
          )}
          <form className='form w-100' onSubmit={formik.handleSubmit} noValidate>
            {/* begin::Heading */}
            <div className='card-body'>
              <div className='mb-5 text-start'>
                <a href='#' className='mb-4 d-flex flex-center'>
                  <h1 className='text-dark' data-kt-translate='sign-in-title'>
                    Sign In
                  </h1>
                </a>
              </div>
              <div className='sign-google'>
                <a
                  href=''
                  className='symbol symbol-circle symbol-45px me-3'
                  onClick={(e) => {
                    e.preventDefault()
                    handleSSOLogin('google')
                  }}
                >
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
                    className=''
                  />
                  Sign in with Google
                </a>
              </div>

              <div className='sign-google'>
                <a
                  href=''
                  className='symbol symbol-circle symbol-45px me-3'
                  onClick={(e) => {
                    e.preventDefault()
                    handleSSOLogin('microsoft')
                  }}
                >
                  <img
                    alt='Logo'
                    src='https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg'
                    className=''
                  />
                  Sign in with Microsoft
                </a>
              </div>
              <div
                className='text-gray-400 fs-6 mb-5 text-center me-md-6'
                data-kt-translate='general-or'
              >
                Or with email
              </div>
              <div className='fv-row mb-5'>
                <label className='form-label fs-6  text-dark'>Email</label>
                <input
                  placeholder='Email'
                  value={formik?.values?.email}
                  onChange={formik.handleChange}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.email && formik.errors.email},
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                  type='email'
                  name='email'
                  autoComplete='off'
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <span role='alert' className='text-danger'>
                      {formik.errors.email}
                    </span>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex flex-stack mb-2'>
                    <label className='form-label text-dark fs-6 mb-0'>Password</label>
                    {/* end::Link */}
                  </div>
                </div>
                <div className='password-wrap'>
                  <input
                    type={passwordType.password ? 'password' : 'text'}
                    placeholder='Password'
                    autoComplete='off'
                    name='password'
                    value={formik?.values?.password}
                    onChange={formik.handleChange}
                    className={clsx(
                      'form-control form-control-lg form-control-solid'
                      // {
                      //   'is-invalid': formik.touched.password && formik.errors.password,
                      // },
                      // {
                      //   'is-valid': formik.touched.password && !formik.errors.password,
                      // }
                    )}
                  />

                  <span
                    className='svg-icon svg-icon-3'
                    onClick={() => {
                      setPasswordType({...passwordType, password: !passwordType.password})
                    }}
                  >
                    {passwordType.password ? (
                      <i className='bi bi-eye-fill'></i>
                    ) : (
                      <i className='bi bi-eye-slash-fill'></i>
                    )}
                  </span>
                </div>
                {formik.touched.password && formik.errors.password && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert' className='text-danger'>
                        {formik.errors.password}
                      </span>
                    </div>
                  </div>
                )}
                {isCellcast && (
                  <div className='forgot-pass'>
                    <Link
                      to='/auth/forgot-password'
                      className='link-primary fs-6 fw-bolder d-block text-end mt-3'
                    >
                      Forgot Password ?
                    </Link>
                  </div>
                )}

                {/* <ReCAPTCHA
                  sitekey={GoogleRecapchaKey} // Replace with your site key
                  onChange={(val: any) => console.log(val)}
                /> */}
              </div>
              {/* end::Form group */}

              {/* begin::Action */}
              <div className=''>
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn  me-2 flex-shrink-0 auth-primary-btn w-100'
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && (
                    <span className='indicator-label text-white' data-kt-translate='sign-in-submit'>
                      Sign In
                    </span>
                  )}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>

                <div className='d-flex flex-stack justify-content-center py-2 mt-8'>
                  <div className='me-2'></div>
                  {isCellcast && (
                    <div className='m-0'>
                      <span
                        className='text-gray-400 fw-bold fs-5 me-2'
                        data-kt-translate='sign-in-head-desc'
                      >
                        Not a Member yet?
                      </span>
                      <a
                        className='link-primary fw-bold fs-5'
                        data-kt-translate='sign-in-head-link'
                        href='https://www.cellcast.com/au/sign-up-2'
                      >
                        Sign Up
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {isCellcast && (
              <div className='auth-bottom-pages'>
                <ul>
                  <li>
                    <a target='_blank' href='https://www.cellcast.com/au/legal/terms-of-use' rel="noreferrer">
                      Terms
                    </a>
                  </li>
                  <li>
                    <a target='_blank' href='https://www.cellcast.com/au/legal/privacy-policy' rel="noreferrer">
                      Privacy
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:info@cellcast.com`}>Contact us</a>
                  </li>
                </ul>
              </div>
            )}
          </form>
        </>
      }
    </>
  )
}
